import { SITE_URL, OFFICIAL_LINKS, pathFor, LANGS } from "../config/site";

const PERSON = {
  "@type": "Person",
  name: "Jennifer Lopez",
  alternateName: "JLo",
  birthDate: "1969-07-24",
  birthPlace: { "@type": "Place", name: "The Bronx, New York, United States" },
  jobTitle: ["Singer", "Actor", "Dancer", "Producer"],
  nationality: "American",
  sameAs: [
    OFFICIAL_LINKS.website,
    "https://www.imdb.com/name/nm0000182/",
    "https://www.britannica.com/biography/Jennifer-Lopez",
  ],
};

export function websiteLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Independent Jennifer Lopez Tribute",
    url: SITE_URL,
    description: "An independent multilingual tribute and timeline about Jennifer Lopez. Not an official website.",
    inLanguage: LANGS.map((l) => l.code),
    publisher: {
      "@type": "Organization",
      name: "Independent Tribute Website",
      url: SITE_URL,
    },
  };
}

export function webpageLd({ lang, pageKey, title, description }) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url: SITE_URL + pathFor(lang, pageKey),
    inLanguage: lang,
    isPartOf: { "@type": "WebSite", name: "Independent Jennifer Lopez Tribute", url: SITE_URL },
    about: PERSON,
  };
}

export function breadcrumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: SITE_URL + it.path,
    })),
  };
}

export function personLd() {
  return { "@context": "https://schema.org", ...PERSON };
}

export function articleLd({ lang, pageKey, headline, description }) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline,
    description,
    inLanguage: lang,
    mainEntityOfPage: SITE_URL + pathFor(lang, pageKey),
    about: PERSON,
    author: { "@type": "Organization", name: "Independent Tribute Website" },
    publisher: { "@type": "Organization", name: "Independent Tribute Website", url: SITE_URL },
  };
}

export function faqLd(faqArray) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqArray.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
